import { lt } from '@mews/framework';
import { SearchType } from '@mews-commander/enums';
import { SearchHookField } from '../../../../../../components/form/hookFields';

export const OwnerFilter = ({ name }: { name: string }) => (
    <SearchHookField
        data-test-id="owner-filter"
        name={name}
        label={lt('Owner')}
        searchTypes={[SearchType.Company, SearchType.Customer]}
    />
);
